import { getConfig } from '@superbet-group/web.lib.config';
import {
    createCTRestClient,
    RestClient,
} from '@superbet-group/web.lib.rest';
import { defaultHttpTimeoutMs } from '@core/constants';
import { getClientSourceParam } from '@superbet-group/web.lib.vue-utilities';
import { getCsrfToken } from '@core/services/authentication/helpers';
import {
    HtmlTag,
    SeoMetaInformation,
} from '@src/app/utils/seoEngine';

export default class RestService {
    private readonly restClient: RestClient = createCTRestClient(
        getConfig().seoEngineConfig!.url,
        defaultHttpTimeoutMs || 100,
        getClientSourceParam(),
        true,
        getCsrfToken,
    );

    public getMetadata(url: string): Promise<MetaDataResponse> {
        return this.restClient.get<MetaDataResponse>(
            'getMetaData', {
                params: {
                    uri: url,
                },
            },
        );
    }
}

type MetaDataResponse = {
    Title: string;
    Canonical: string;
    MetaTags: SeoMetaInformation[] | null;
    HtmlTags: HtmlTag[] | null;
};
